export function validPhoneNumber(number) {
    if(!number) {
        return false
    }
    let digits = number.replace(/\D/g, '');
    return digits.length === 10;
}

export function validEmail(email) {
    if(!email) {
        return false;
    }
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export function validHex(hex) {
    if(!hex) {
        return false;
    }
    const re = /^#[a-f0-9]{6}$/;
    return re.test(hex.toLowerCase());
}

export function validUrl(url) {
    if(!url) {
        return false;
    }
    const re = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
    return re.test(url);
}

export function validCurrency(currency) {
    if(!currency) {
        return false;
    }
    const re = /^\d+(\.\d{2})?$/;
    return re.test(currency);
}

export function validPostalCode(postal_code) {
    if(!postal_code) {
        return false;
    }
    const re = /^\d{5}(-\d{4})?$/;
    return re.test(postal_code);
}

export function windowSize(minWidth, maxWidth) {
    const innerWidth = window.innerWidth;
    const breakpoints = {
        xxl: 1920,
        xl: 1440,
        lg: 1200,
        md: 992,
        sm: 768
    }
    if(minWidth && !maxWidth) {
        return innerWidth >= breakpoints[minWidth];
    }
    if(!minWidth && maxWidth) {
        return innerWidth < breakpoints[maxWidth];
    }
    return innerWidth >= breakpoints[minWidth] && innerWidth < breakpoints[maxWidth];
}

export function testEnvironment() {
    if(window.APP_ENV) {
        return window.APP_ENV !== "production";
    }
    return false;
}
